export default __webpack_public_path__ + "locales/sq-AL/Translations.json?hash=5cc54d901b54553fe50243c4ed37bc5f";